import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  fill?: string;
};

/** Support / help bubble with note lines (dashboard customer support). */
const CustomerSupportIcon = ({ className, fill = "black" }: Props) => {
  return (
    <svg
      className={cn("h-[21px] w-[22px] shrink-0", className)}
      viewBox="0 0 22 21"
      fill={fill || "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3839 11.3057C14.8511 11.3057 15.2299 11.6674 15.23 12.1134C15.23 12.5594 14.8511 12.921 14.3839 12.9211H7.61493C7.14764 12.9211 6.76882 12.5595 6.76882 12.1134C6.76893 11.6674 7.14771 11.3057 7.61493 11.3057H14.3839Z"
        fill={fill}
      />
      <path
        d="M14.3839 8.07487C14.8511 8.07493 15.2299 8.43662 15.23 8.88258C15.23 9.32862 14.8511 9.69023 14.3839 9.69028H7.61493C7.14764 9.69028 6.76882 9.32866 6.76882 8.88258C6.76893 8.43659 7.14771 8.07487 7.61493 8.07487H14.3839Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7166 0.0222918C14.3805 0.188308 16.8904 1.27374 18.7781 3.07563C20.6657 4.87756 21.8027 7.2736 21.9766 9.81648C22.1505 12.3592 21.3494 14.8757 19.7234 16.8965C18.0972 18.9174 15.7564 20.3049 13.1378 20.8001C10.6466 21.2712 8.06643 20.9027 5.83181 19.7669L2.22754 20.9145C1.92947 21.0094 1.60956 21.0228 1.30375 20.954C0.997846 20.885 0.717892 20.7362 0.49564 20.5241C0.27342 20.3119 0.117499 20.0446 0.0453129 19.7527C-0.0267601 19.4608 -0.0127597 19.1553 0.0866273 18.8708L0.0874536 18.87L1.29218 15.4333C0.102826 13.3004 -0.282819 10.8375 0.21057 8.45979C0.729393 5.96019 2.18294 3.7256 4.29987 2.17327C6.4168 0.621094 9.05296 -0.143644 11.7166 0.0222918ZM11.6067 1.63454C9.35273 1.49409 7.12158 2.14074 5.33025 3.45424C3.53904 4.76773 2.30959 6.6587 1.87058 8.77373C1.43168 10.8888 1.81342 13.0844 2.94476 14.9506C3.06626 15.151 3.09185 15.392 3.01499 15.6116L1.6921 19.3811L5.64672 18.123L5.73348 18.1002C5.93863 18.0574 6.15471 18.0887 6.33832 18.1901C8.29334 19.2702 10.5932 19.6345 12.809 19.2155C15.0247 18.7964 17.0055 17.6228 18.3815 15.9129C19.7574 14.2029 20.4348 12.0731 20.2877 9.92139C20.1405 7.76981 19.1788 5.74242 17.5816 4.21777C15.9844 2.69314 13.8607 1.77505 11.6067 1.63454Z"
        fill={fill}
      />
    </svg>
  );
};

export default CustomerSupportIcon;
